<script>
	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="additional-information" on:submit={handleSubmit}>
		<FormRowColumn rowClass="justify-content-center confirmation-hide">
			<h4 class="text-center">{@html projectSettings.classActionName}</h4>
			<h1 class="text-center">Part 7: Additional Information</h1>
		</FormRowColumn>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<FormRowColumn>
				<YesNoGroup
					required
					{disabled}
					name="hasAdditionalInformation"
					label="Is there anything else you'd like to tell us?"
					sublabel="You do not need to complete this part, but you can use this part to tell us any further information."
					bind:value={$model.hasAdditionalInformation}
				/>
			</FormRowColumn>

			{#if $model.hasAdditionalInformation == "Yes"}
				<FormRowColumn>
					<TextArea
						required
						{disabled}
						label="Additional Details"
						bind:value={$model.additionalInformation}
					/>
				</FormRowColumn>
			{/if}

			<FormRowColumn rowClass="justify-content-center confirmation-hide">
				<h1 class="text-center">Part 8: Authorisation</h1>
			</FormRowColumn>

			<hr class="primary" />

			<FormRowColumn>
				<YesNoGroup
					required
					{disabled}
					name="agreeToAdministratorInformation"
					label="I agree that the Administrator can use the information provided in this Registration Form to decide if I have an eligible claim, including by sharing this information with other persons and bodies."
					sublabel="If you do not agree to the Administrator using and sharing the information in this form, this may mean the Administrator is unable decide if you are eligible to receive a payment."
					bind:value={$model.agreeToAdministratorInformation}
				/>
			</FormRowColumn>
		</div>

		<FormRowColumn rowClass="confirmation-hide">
			<NavigationButtons bind:buttons />
		</FormRowColumn>
	</Form>
</PageSection>

<style>
</style>
